/** Thin wrapper around window.Telegram.WebApp with a no-op fallback for the browser. */

export function tg(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

export function initTelegram(): void {
  const app = tg();
  if (!app) return;
  try {
    app.ready();
    app.expand();
    app.disableVerticalSwipes?.();
  } catch {
    // older clients may lack some calls — ignore
  }
}

/**
 * initData for the API header. Inside Telegram it's the signed string; for local
 * development (localhost only) a signed test payload can be passed via
 * `#dev_init=<urlencoded initData>`.
 */
export function getInitData(): string {
  const fromTg = tg()?.initData ?? "";
  if (fromTg) return fromTg;
  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    const hash = new URLSearchParams(location.hash.slice(1));
    return hash.get("dev_init") ?? "";
  }
  return "";
}

export const haptic = {
  tap(): void {
    tg()?.HapticFeedback?.impactOccurred("light");
  },
  success(): void {
    tg()?.HapticFeedback?.notificationOccurred("success");
  },
  error(): void {
    tg()?.HapticFeedback?.notificationOccurred("error");
  },
};

/** Inside Telegram: the client's scheme. Outside (dev/browser): the OS preference. */
export function colorScheme(): "light" | "dark" {
  const app = tg();
  if (app?.initData) return app.colorScheme;
  return window.matchMedia?.("(prefers-color-scheme: light)").matches ? "light" : "dark";
}

export function closeApp(): void {
  const app = tg();
  if (app) app.close();
}
